import React from 'react';

const PromptList = ({ prompts, onSelectPrompt, selectedPrompt }) => {
  // Define light colors for each prompt type
  const getBackgroundColor = (type, isSelected) => {
    if (isSelected) {
      return '#4790CF'; // Keep the blue color for selected items
    }
    switch (type) {
      case 'system':
        return '#E3F2FD'; // Light blue
      case 'classification':
        return '#F1F8E9'; // Light green
      case 'query':
        return '#FFFDE7'; // Light yellow
      case 'composition':
        return '#FFF3E0'; // Light orange
      case 'generation':
        return '#F3E5F5'; // Light lavender
      case 'error':
        return '#FFEBEE'; // Light red for error
      default:
        return 'white'; // Default color
    }
  };

  return (
    <div className="w-full bg-gray-100 p-4">
      <h2 className="text-lg font-bold mb-4">Prompts</h2>
      <ul className="space-y-2">
        {prompts.map((prompt) => {
          const isSelected = selectedPrompt && selectedPrompt.id === prompt.id;
          return (
            <li
              key={prompt.id}
              onClick={() => onSelectPrompt(prompt)}
              className={`cursor-pointer p-2 rounded-lg shadow transition h-20 flex flex-col justify-center ${
                isSelected ? 'text-white' : 'hover:bg-gray-200 text-gray-800'
              }`}
              style={{
                backgroundColor: getBackgroundColor(prompt.type, isSelected),
                minWidth: '100%',
              }}
            >
              <span className="truncate">{prompt.name}</span>
              <span
                className={`text-sm ${
                  isSelected ? 'text-white' : 'text-gray-500'
                }`}
              >
                Type: {prompt.type}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PromptList;
